import React from "react";
import { useNavigate } from "react-router-dom";
import ActionBar from "../ActionBar/ActionBar";
import "./Instructions.css";
import "../../auth.css";
import WhatsAppWidget from "../WhatsAppWidget/WhatsAppWidget";

const ApplicationInstructions = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Logo header */}
      <header className="si__header">
        <div className="si__brand">
          <img className="si__logo" src="/assets/images/Ramzan_Logo_3-removebg-preview.png" alt="Ramzan Scholarship" />
          <span className="si__portal">Scholarship Application Portal</span>
        </div>
      </header>

      {/* Content */}
      <div className="inst">
        <div className="inst__hero">
          <div className="inst__brand" style={{ marginBottom: 22 }}>
            {/* <div className="inst__logo">R</div>
            <span>Ramran Talent Scholarship Program</span> */}
          </div>
          <span className="inst__pill">Applications open</span>
          <h1 className="inst__title">Instructions</h1>
          <p className="inst__lead">
            Welcome! You have started an application for the <b>Ramzan Talent Scholarship Program 2026</b>.
          </p>
          <p className="inst__sub">
            Thank you for your interest in the program. Please read the instructions below before you begin.
          </p>
        </div>

        {/* Deadline card */}
        <div className="inst__deadline">
          <span className="inst__deadline-label">Application deadline</span>
          <strong>Friday, December 18 2026</strong>
          <span>11:59 PM (PST)</span>
        </div>

        {/* Before you apply */}
        <div className="inst__card">
          <h3>Before you apply</h3>
          <p>
            It is your responsibility to complete and submit the application and all required materials before the deadline.
            We do not grant extensions or accept late applications.
          </p>
          <p>
            Final decisions will be announced by <b>25th December 2026</b>. Final applicants will be notified by email.
          </p>
        </div>

        {/* Completing your application */}
        <div className="inst__card">
          <h3>Completing your application</h3>
          <ul className="inst__list">
            <li>Please complete all sections of the application.</li>
            <li>
              Click <b>Continue</b> to save your work and move to the next section.
            </li>
            <li>
              You do not need to complete the entire application at one time. You can return to any section and make changes before submission.
            </li>
            <li>
              When ready, review all sections and click <b>Submit Application</b> to submit.
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="inst__contact">
          Need help? Contact us at{" "}
          <a href="mailto:scholorship@ramzan.org.pk">scholorship@ramzan.org.pk</a>.
        </div>

        <p className="start-hint">Click <b>Continue</b> to begin your application.</p>

        {/* Spacer so content doesn't sit right against action bar */}
        <div className="inst__spacer" />
      </div>

      {/* Bottom action bar — Continue only, no Back */}
      <ActionBar
        onNext={() => navigate("/application/personal-information")}
        nextLabel="Continue →"
        hideBack
      />
      <WhatsAppWidget />
    </div>
  );
};

export default ApplicationInstructions;
